module.exports = __webpack_public_path__ + "img/email.92cefc72.svg";